"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createReducer;
var _reduxImmutable = require("redux-immutable");
var _immutable = require("connected-react-router/immutable");
var _immutable2 = require("immutable");
var _history = _interopRequireDefault(require("./utils/history"));
var _globalReducer = _interopRequireDefault(require("./globalReducer"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * Combine all reducers in this file and export the combined reducers.
 */

const routeInitialState = (0, _immutable2.fromJS)({
  location: null
});
function routeReducer() {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : routeInitialState;
  let action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case _immutable.LOCATION_CHANGE:
      return state.merge({
        location: action.payload
      });
    default:
      return state;
  }
}

/**
 * Merges the main reducer with the router state and dynamically injected reducers
 */
function createReducer() {
  let injectedReducers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const rootReducer = (0, _reduxImmutable.combineReducers)({
    router: routeReducer,
    global: _globalReducer.default,
    ...injectedReducers
  });

  // Wrap the root reducer and return a new root reducer with router state
  const mergeWithRouterState = (0, _immutable.connectRouter)(_history.default);
  return mergeWithRouterState(rootReducer);
}